export default class Flex{
    static ROW:string = "row";
    static ROW_REVERSE:string = "row_rev";
    static COLUMN:string = "col";
    static COLUMN_REVERSE:string = "col_rev";


    static FLEX_START:string = "flexStart";
    static FLEX_END:string = "flexEnd";
    static CENTER:string = "center";
    static STRETCH:string = "stretch";
}